"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testPhoneNumber = void 0;
const constants_1 = require("./constants");
/**
 * Use `isValidPhoneNumber`
 * @deprecated
 */
const testPhoneNumber = (segment, value) => {
    const PhoneNumberRegex = {
        [constants_1.Segment.Fixter_UK]: /((\+44(\s\(0\)\s|\s0\s|\s)?)|0)7\d{3}(\s)?\d{6}/,
        [constants_1.Segment.Fixter_FR]: /^((\+)33|0|0033)[1-9](\d{2}){4}$/g,
        [constants_1.Segment.Motrio_FR]: /^((\+)33|0|0033)[1-9](\d{2}){4}$/g,
    };
    const segmentRegex = PhoneNumberRegex[segment];
    if (!segmentRegex)
        return false;
    const result = segmentRegex.test(value);
    segmentRegex.lastIndex = 0;
    return result;
};
exports.testPhoneNumber = testPhoneNumber;
//# sourceMappingURL=phoneValidation.js.map